import React from 'react';
import { motion } from 'framer-motion';
import { FaLaptopCode, FaJava, FaReact, FaDatabase } from 'react-icons/fa';

const About = () => {
  const stats = [
    { label: "2+ Years Experience", value: "2+" },
    { label: "20+ Projects", value: "20+" },
    { label: "10+ Happy Clients", value: "10+" },
    { label: "5+ Technologies", value: "5+" },
  ];

  return (
    <div id="about" className="w-full section-padding relative">
      <motion.div 
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="flex flex-col gap-10"
      >
        <div className="flex items-center gap-4">
          <span className="text-accent-primary font-mono text-xl">01.</span>
          <h2 className="text-3xl sm:text-4xl font-display font-bold">About Me</h2>
          <div className="h-[1px] flex-grow bg-slate-800 ml-4 max-w-[300px]" />
        </div>

        <div className="flex flex-col md:flex-row gap-16 items-center px-4">
          {/* Image Content */}
          <motion.div 
            whileHover={{ scale: 1.05 }}
            transition={{ type: 'spring' }}
            className="relative w-full md:w-1/3 flex justify-center group"
          >
             <div className="relative z-10 w-64 h-64 sm:w-80 sm:h-80 overflow-hidden rounded-2xl border-2 border-accent-primary group-hover:scale-105 group-hover:-translate-y-2 group-hover:-translate-x-2 transition-all duration-300">
                <img 
                  src="https://picsum.photos/seed/dev/400/400" 
                  alt="Developer Profile"
                  className="w-full h-full object-cover grayscale brightness-110 group-hover:grayscale-0 group-hover:scale-110 transition-all duration-500"
                />
             </div>
             {/* Glowing border ring effect */}
             <div className="absolute top-4 left-4 -z-10 w-64 h-64 sm:w-80 sm:h-80 rounded-2xl border-2 border-accent-primary/40 group-hover:translate-y-4 group-hover:translate-x-4 transition-all duration-300 animate-glow-pulse" />
          </motion.div>

          {/* Text Content */}
          <div className="w-full md:w-2/3 flex flex-col gap-6">
            <p className="text-lg leading-relaxed text-slate-300">
              Hello! My name is <span className="text-white font-bold">Yash Patel</span> and I enjoy creating things that live on the internet. My journey in web development started back in 2020 when I decided to try editing custom Tumblr themes — turns out hacking together a custom reblog button taught me a lot about HTML & CSS!
            </p>
            <p className="text-lg leading-relaxed text-slate-300">
              Fast-forward to today, and I've had the privilege of working at a start-up, a huge corporation, and as a freelancer. My main focus these days is building <span className="text-accent-primary">accessible, inclusive products</span> and digital experiences for a variety of clients.
            </p>
            <p className="text-lg leading-relaxed text-slate-300">
              I also recently launched a course that covers everything you need to build a web app with the <span className="text-accent-primary">MERN stack</span>.
            </p>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-6">
              {stats.map((stat, idx) => (
                <motion.div 
                  key={idx}
                  whileHover={{ y: -5 }}
                  className="glass p-4 rounded-xl text-center border-t border-accent-primary/20"
                >
                   <h4 className="text-2xl font-bold text-accent-primary">{stat.value}</h4>
                   <p className="text-xs uppercase tracking-widest text-slate-500 font-mono mt-1">{stat.label}</p>
                </motion.div>
              ))}
            </div>

            <div className="mt-8">
              <button className="btn-primary">Download CV</button>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default About;
